import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react';
import Div from '../Div';

export default function SocialWidget() {
  return (
    <Div className="cs-social_btns cs-style1">
      <Link to='https://www.youtube.com/@TiaPatymotricidade/shorts' className="cs-center">
        <Icon icon="fa6-brands:youtube" />              
      </Link>

      <Link to='https://www.instagram.com/tiapaty.motricidade/' className="cs-center">
        <Icon icon="fa6-brands:instagram" />              
      </Link>

      <Link to='https://api.whatsapp.com/send/?phone=5567992199121&text=Ol%C3%A1+gostaria+de+informa%C3%A7%C3%B5es+sobre+a+sess%C3%A3o+de+psicomotricidade&type=phone_number&app_absent=0' className="cs-center">
        <Icon icon="fa6-brands:whatsapp" />              
      </Link>
    </Div>
  )
}
